import React, { useState } from 'react';
import { gql, useQuery, useMutation } from '@apollo/client';
import { formatDateTime } from '../utils/helpers';
import './Whitelist.css';

const GET_WHITELIST = gql`
  query { whitelist { id droneId label addedBy addedAt } }
`;
const ADD = gql`
  mutation AddToWhitelist($droneId: String!, $label: String) {
    addToWhitelist(droneId: $droneId, label: $label) { id droneId label }
  }
`;
const REMOVE = gql`
  mutation RemoveFromWhitelist($id: ID!) { removeFromWhitelist(id: $id) }
`;

export default function Whitelist() {
  const [droneId, setDroneId] = useState('');
  const [label, setLabel] = useState('');
  const { data, refetch } = useQuery(GET_WHITELIST);
  const [add] = useMutation(ADD);
  const [remove] = useMutation(REMOVE);

  const handleAdd = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!droneId.trim()) return;
    await add({ variables: { droneId: droneId.trim(), label: label.trim() || undefined } });
    setDroneId(''); setLabel('');
    refetch();
  };

  const handleRemove = async (id: string) => {
    await remove({ variables: { id } });
    refetch();
  };

  return (
    <div className="page-container">
      <div className="page-header"><h2>✅ Whitelist (Friendly Drones)</h2></div>

      <form className="add-form" onSubmit={handleAdd}>
        <input className="input-field" placeholder="Drone ID (e.g. A1B2C3D4)" value={droneId} onChange={e => setDroneId(e.target.value)} required />
        <input className="input-field" placeholder="Label (optional)" value={label} onChange={e => setLabel(e.target.value)} />
        <button className="btn-primary" type="submit">+ Add to Whitelist</button>
      </form>

      <div className="table-wrap">
        <table className="data-table">
          <thead>
            <tr><th>Drone ID</th><th>Label</th><th>Added By</th><th>Added At</th><th>Action</th></tr>
          </thead>
          <tbody>
            {(data?.whitelist || []).map((w: any) => (
              <tr key={w.id}>
                <td><code className="id-code">{w.droneId}</code></td>
                <td>{w.label || '—'}</td>
                <td>{w.addedBy || '—'}</td>
                <td>{formatDateTime(w.addedAt)}</td>
                <td><button className="btn-danger btn-xs" onClick={() => handleRemove(w.id)}>Remove</button></td>
              </tr>
            ))}
          </tbody>
        </table>
        {(data?.whitelist || []).length === 0 && <div className="no-data">Whitelist is empty</div>}
      </div>
    </div>
  );
}
